import _ from 'lodash'
import store from '@/store/index'
import Cargos from './Cargos'

export default {
  podeMostrarModulo(arrCargosNecessarios) {
    if (store.getters['autenticacao/userObj'].usuario) {
      const { role } = store.getters['autenticacao/userObj'].usuario

      return this._isAdministrador(role)
        || _.includes(arrCargosNecessarios, role)
    }

    return false
  },
  podeLiberarRota(arrCargoNecessario) {
    if (store.getters['autenticacao/userObj'].usuario) {
      const { role } = store.getters['autenticacao/userObj'].usuario

      return this._isAdministrador(role)
        || _.includes(arrCargoNecessario, role)
    }

    return false
  },
  _isAdministrador(cargoUsuario) {
    return cargoUsuario === Cargos.ADMINISTRADOR
  },
}
